export default __webpack_public_path__ + "static/media/03-460x460.86a4bf57.jpeg";